import { StatePropertyRef } from '../../canvas/ExtendableStore';

export type GesturesInfo = {
    confetti: boolean,
    pen: boolean,
    ping: boolean,
};

export const CreateGesturesInfo = (values: GesturesInfo) => values;
export const GesturesInfo = StatePropertyRef<GesturesInfo>('gestures', CreateGesturesInfo({
    confetti: true,
    pen: true,
    ping: true,
}));
